import React, { FC } from "react";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { REGISTER_STREAMER_URL } from "../../links";
import mobilePreview from "../../images/starfarm-mobile-preview.png";
import Button from "@material-ui/core/Button";

interface IListenerSectionProps {}

const ListenerSection: FC<IListenerSectionProps> = (props) => {

  return (
    <section
      style={{
        position: "relative",
        background: "linear-gradient(rgb(27, 28, 77), rgb(29, 194, 186) 89%)",
        minHeight: "100vh",
        padding: "100px 0",
        zIndex: 999,
      }}
    >
      <Container>
        <Grid
          style={{ height: "100%" }}
          justify="space-between"
          alignItems="center"
          container={true}
        >
          <Grid item={true} xs={12} sm={12} md={12} lg={6} xl={6}>
            <img
              src={mobilePreview}
              style={{ maxHeight: 800, maxWidth: "100%" }}
              height="auto"
              width="auto"
              alt=""
            />
          </Grid>
          <Grid item={true} xs={12} sm={12} md={12} lg={6} xl={6}>
            <Box display="flex" alignItems="flex-end" mb={4}>
              <Typography
                style={{
                  letterSpacing: -24,
                  fontWeight: 500,
                  fontSize: 180,
                  color: "white",
                  marginRight: 26,
                }}
              >
                //
              </Typography>
              <Typography
                style={{
                  letterSpacing: -5,
                  fontWeight: 500,
                  fontSize: 110,
                  lineHeight: "85px",
                  color: "white",
                }}
                gutterBottom
                variant="h1"
              >
                as the listener
                <span style={{ color: "#4155ff", fontFamily: "cursive" }}>
                  .
                </span>
              </Typography>
            </Box>

            <Typography variant="h4" style={{ color: "white", marginBottom: 40 }}>
              A place to enjoy, discover and support artists. Listen on the web or on mobile.
            </Typography>

            <Box display="flex" justifyContent="flex-start">
              <Button
                component="a"
                href={REGISTER_STREAMER_URL}
                variant="contained"
                color="secondary"
                style={{
                  borderRadius: 25,
                  padding: "14px 56px",
                  textTransform: "uppercase",
                  fontSize: 16,
                  fontWeight: 500,
                  minWidth: 200,
                }}
              >
                start listening
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default ListenerSection;

